import { LazyLoadedStates, LazyLoadedStatesManager } from '@edl-development/edl-common';

export const DashboardLazyLoadedStates = new LazyLoadedStatesManager<{ 
    base: LazyLoadedStates
    view: LazyLoadedStates
}> ({
    base: {
        name: 'authenticated.dashboard',
        url: '/dashboard',
    },
    view: {
        name: 'authenticated.dashboard.view',
        url: '/home',
    }
}, 
() => import('src/app/dashboard/dashboard.module').then((result: {DashboardModule: any}) => result.DashboardModule)
);
